<template>
  <span>
    <span v-if="status[id]">{{ status[id] }}</span>
    <span v-else>Неизвестно</span>
  </span>
</template>
<script>
export default {
  methods: {
    changeRegion() {
      this.$emit("changeRegion", this.region);
    },
  },

  data: () => ({
    status: {
      0: "Отказ",
      1: "У отправителя",
      2: "Курьер принял",
      3: "В офисе отправления",
      4: "В офисе доставки",
      5: "Курьер доставляет",
      6: "Доставлен",
      7: "Возврат",
      8: "В промежуточном офисе",
      31: "На складе",
      32: "В мешке",
      33: "В перевозке",
      34: "В РЦ Курьера",
    },
  }),
  props: ["id"],
};
</script>
<style>
</style>
 